import { ApolloLink, Observable } from '@apollo/client';

const resilientSubscriptionLink = new ApolloLink((operation, forward) =>
  new Observable((observer) => {
    let current;

    const start = () => {
      current = forward(operation).subscribe({
        next: (value) => observer.next(value),
        error: (error) => observer.error(error),
        complete: () => start(),
      });
    };

    start();

    return () => {
      if (current) current.unsubscribe();
    };
  })
);

export default resilientSubscriptionLink;
